import React, { useState } from 'react';
import { ClockOutline } from 'iconoir-react';
import { showData } from '../../../../service/Contrato/showData';
import { HistoricalModal } from './historical/HistoricalModal';

export const HistoricalSol = ({ tableMeta }) => {
    const [show, setShow] = useState(false);
    const [records, setRecords] = useState([]);
    const [status, setStatus] = useState('loading'); // loading | ready | error

    const handleOpen = () => {
        const token = window.sessionStorage.getItem('token');
        setShow(true);
        setStatus('loading');
        showData('GET', token, `/api/historical/buy/${tableMeta.id}/`)
            .then((res) => {
                if (!Array.isArray(res?.data)) throw new Error(res?.msg);
                setRecords(res.data);
                setStatus('ready');
            })
            .catch(() => setStatus('error'));
    };

    return (
        <>
            <button
                className='p-1 cursor-pointer bg-gray-500 hover:bg-gray-600 text-white rounded-md'
                onClick={handleOpen}
                title="Ver histórico"
                aria-label="Ver histórico de la solicitud"
            >
                <ClockOutline />
            </button>
            {show && <HistoricalModal onHide={() => setShow(false)} records={records} status={status} />}
        </>
    );
};
